import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Button, Row, Col, FormGroup, Input, Label } from 'reactstrap';
// organizar o encapsulamento de componentes no SignUpFormBase
import { compose } from 'recompose';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import MenuPrincipal from '../../menu/menuPrincipal';
import Rodape from "../../rodape/rodape";


const SignUpPage = () => (
    <div>
        <MenuPrincipal />
        <header className="masthead">
            <div className="container h-100">
                <div className="row h-100 align-items-center justify-content-center ">
                    <SignUpForm />
                </div>
            </div>
        </header>
        <Rodape />
    </div>
);

const INITIAL_STATE = {
    username: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
};

class SignUpFormBase extends Component {
    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    onSubmit = event => {
        const { username, email, passwordOne } = this.state;

        this.props.firebase.doCreateUserWithEmailAndPassword(email, passwordOne)
            .then(() => {
                this.props.history.push(ROUTES.SIGN_IN);
            })
            .catch(error => {
                console.log("Não criou a conta");
                this.setState({ error });
            });
        // evita que a página seja recarrega devido a ação submit
        event.preventDefault();
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const {
            username,
            email,
            passwordOne,
            passwordTwo,
            error,
        } = this.state;

        const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === '' ||
            email === '' ||
            username === '';

        return (
            <div>
                <h1 className="text-white font-weight-bold">Crie sua conta</h1>

                <form onSubmit={this.onSubmit}>
                    <FormGroup>
                        <Label className="texto-branco">Nome</Label>
                        <Input name="username" type="text" placeholder="Nome Completo" value={username} onChange={this.onChange} />
                    </FormGroup>

                    <FormGroup>
                        <Label className="texto-branco">e-mail</Label>
                        <Input name="email" type="text" placeholder="Endereço de email" value={email} onChange={this.onChange} />
                    </FormGroup>

                    <FormGroup>
                        <Label className="texto-branco">Senha</Label>
                        <Input name="passwordOne" type="password" placeholder="senha" value={passwordOne} onChange={this.onChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label className="texto-branco">Confirmar Senha</Label>
                        <Input name="passwordTwo" type="password" placeholder="senha" value={passwordTwo} onChange={this.onChange} />
                    </FormGroup>
                    <FormGroup>
                        <Button disabled={isInvalid} type="submit" color="primary">Criar Conta</Button>
                    </FormGroup>
                    {error &&
                        error.code == "auth/invalid-email" &&
                        <p className="text-branco"> Informe um endereço de email válido</p>
                    }

                    {
                        error &&
                        error.code == "auth/email-already-in-use" &&
                        <p className="texto-banco">Este e-mail já está em uso</p>
                    }
                </form>
            </div>
        );
    }
}

const SignUpLink = () => (
    <p className="texto-branco">
        Não Possui uma Conta? <Link to={ROUTES.SIGN_UP}>Crie aqui!</Link>
    </p>
);

const SignUpForm = compose(
    withRouter,
    withFirebase,
)(SignUpFormBase);

export default SignUpPage;

export { SignUpForm, SignUpLink };